const baseApiUrl = process.env.REACT_APP_BASE_API_URL;
const SSO_URL = process.env.REACT_APP_SSO_URL;

export const BaseConfig = {
  baseApiUrl,
  SSO_URL,
  TenantHeader: 'V1cxU2FXSXlVbXc9'
};
